import { animate, style, transition, trigger } from '@angular/animations';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { PropertiesService } from '@core/services/properties.service';
import { CustomEventService } from '@shared/services/custom-event.service';

import ActionTypesEnum from '@shared/enums/action-constant.enum';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { NzNotificationService } from "ng-zorro-antd/notification";

@UntilDestroy()
@Component({
  selector: 'app-datasource-list-modal',
  templateUrl: './datasource-list-modal.component.html',
  animations: [
    trigger('slideLeftItem', [
      transition('void => *', [
        style({
          transform: 'translateX(-100%)',
          opacity: '0'
        }),
        animate('200ms ease-in', style({
          transform: 'translateX(0)',
          opacity: 1
        }))
      ]),
      transition('* => void', [
        style({
          transform: 'translateX(0)',
          opacity: 1
        }),
        animate('200ms ease-in', style({
          transform: 'translateX(-100%)',
          opacity: 0
        }))
      ]),
    ]),
    trigger('slideRightItem', [
      transition('void => *', [
        style({
          transform: 'translateX(100%)',
          opacity: '0'
        }),
        animate('200ms ease-in', style({
          transform: 'translateX(0)',
          opacity: 1
        }))
      ]),
      transition('* => void', [
        style({
          transform: 'translateX(0)',
          opacity: 1
        }),
        animate('200ms ease-in', style({
          transform: 'translateX(100%)',
          opacity: 0
        }))
      ]),
    ])
  ]
})
export class DatasourceListModalComponent implements OnInit, OnDestroy {

  @Input() addOn;
  @Input() data: any = {};
  @Input() testLoading;
  @Input() testConnectionResult;
  @Input() loading;

  selectedDataSource;
  showDetails = false;
  customEventSubscription: Subscription;

  constructor(private customEventService: CustomEventService,
              public propertiesService: PropertiesService,
              private notificationService: NzNotificationService,
              ) { }

  ngOnInit(): void {
    this.customEventSubscription = this.customEventService.eventAnnounced$
      .pipe(untilDestroyed(this)).subscribe(
      ({ action, data }) => {
        if (action === ActionTypesEnum.CANCEL_DATASOURCE_DETAIL) {
          this.showDetails = false;
        }

        if (action === ActionTypesEnum.SET_DATASOURCE_DETAIL) {
          this.selectedDataSource = data;
          this.showDetails = true;
        }
      });
  }

  addDataSource(): void {
    this.selectedDataSource = null;
    this.showDetails = true;
  }

  editDataSource(dataSource) {
    // resets test result on each edit / add operation
    this.testConnectionResult = undefined;
    this.customEventService.announceEvent(ActionTypesEnum.GET_DATASOURCE_DETAIL, dataSource.id);

  }

  removeDataSource(dataSource) {
    if (this.propertiesService.PLAYGROUND) {
      return;
    }
    this.customEventService.announceEvent(ActionTypesEnum.CLOSE_MODAL);
    this.customEventService.announceEvent(ActionTypesEnum.SHOW_DELETE_CONFIRM_MODAL, {
      dataSource,
      addon: this.addOn
    });
  }

  ngOnDestroy(): void {
    // prevent memory leak when component destroyed
    this.customEventSubscription.unsubscribe();
  }
}
